export interface 検索並び順区分型 {
  値: string;
  ラベル: string;
}

export const 検索並び順区分一覧: 検索並び順区分型[] = [
  {値: '商品名', ラベル: '商品名'},
  {値: '規格容量', ラベル: '規格・容量'},
  {値: 'メーカー名', ラベル: 'メーカー名'},
  {値: '卸', ラベル: '卸'},
];

export const 卸を抜いた検索並び順区分一覧: 検索並び順区分型[] =
  検索並び順区分一覧.filter((value) => value.値 !== '卸');
